import { render, staticRenderFns } from "./newVolDetail.vue?vue&type=template&id=6a394d94&scoped=true&"
import script from "./newVolDetail.vue?vue&type=script&lang=js&"
export * from "./newVolDetail.vue?vue&type=script&lang=js&"
import style0 from "./newVolDetail.vue?vue&type=style&index=0&id=6a394d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a394d94",
  null
  
)

export default component.exports